import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "../../../../customHooks/useForm";
import {useEffect, useState} from "react";
import { actualizarServicio,  registrarServicio} from "../../../../store/thunk/cuentas";
import Grid from "@mui/material/Grid";
import * as React from "react";
import PropTypes from "prop-types";
import BtnCambioEstadoTpv from "../BtnCambioEstadoTpv";
import {useAlphaAlertModal} from "../../../../customHooks/useAlphaAlertModal";
import servicioContratado from "../../../../Repository/ServicioContratado";

const initialCredentials = {
    clientID:"",
    secretID:"",
    hideForUnregisteredAccounts: false,
}

const formValidation = {
    clientID: [(value)=> {
        const regex = /^.+/;
        return regex.test(value);
    },"La llave publia es requerida."],
    secretID: [(value)=> {
        const regex = /^.+/;
        return regex.test(value);
    },"Llave secreta requerida."],
    hideForUnregisteredAccounts:[(value) =>{
        return true;
    }]
}

const FrmCheckout = ({ cuenta_uuid = '',credenciales = initialCredentials,  device = {} }) => {
    const servContratado = new servicioContratado();
    const { servicios } = useSelector(state => state.servicios_plataformas);
    const initialForm = credenciales;
    const frmResult = useForm( initialForm, formValidation );
    const {clientID,secretID, hideForUnregisteredAccounts,  onInputChange, isFormValid, setFormState } = frmResult;
    const [tipoServicio, setTipoServicio ] = useState();
    const { alphaAlert, openAlert, setOpenAlert, setMessageAlert } = useAlphaAlertModal();
    const [saving, setSaving] = useState(false);
    const [currentDevice, setCurrentDevice]= useState(device);

    useEffect(()=>{
        setFormState(credenciales);
    }, [credenciales])

    useEffect(()=>{
        setCurrentDevice(device);
    }, [device])

    useEffect(()=>{
        const checkout = servicios.find( element => element.servicioTipo === 'PAYPAL_CHECKOUT' );
        setTipoServicio(checkout);
    },[servicios])

    const loadComponent = async() =>{
        const result = await servContratado.listar(cuenta_uuid);
        if(result.status === "ok"){
            result.response.contratados.forEach(element =>{
                if(element.tipoServicio === "PAYPAL_CHECKOUT"){
                    setCurrentDevice( element );
                }
            })
        }
    }

    const onClickGuardar = ()=>{
        if(!isFormValid) return;
        if(saving) return;
        const params = {
            ...initialForm,
            clientID,
            secretID,
            hideForUnregisteredAccounts,
        };
        if(device.uuid !== undefined){
            const data = {
                credenciales: params,
                cuenta_uuid,
            }
            actualizar(device.uuid, data);
        }else{
            const newContrato = {
                credenciales: params,
                cuenta_uuid,
                servicioPlataforma_uuid:tipoServicio.uuid
            }
            guardar( newContrato );
        }

    }

    const actualizar = async (uuid, data)=>{
        const result = await servContratado.update(uuid, data);
        if(result.status === 'ok'){
            setMessageAlert("Registro actualizado")
            setOpenAlert(true);
        }else{
            setMessageAlert (result.response);
            setOpenAlert(true);
        }
        await loadComponent();
        setSaving(false);
    }

    const guardar = async (data) =>{
        const result = await servContratado.store(data);
        if(result.status === 'ok'){
            setMessageAlert("Registro creado.")
            setOpenAlert(true);
        }else{
            setMessageAlert (result.response);
            setOpenAlert(true);
        }
        await loadComponent();
        setSaving(false);
    }

    const handleState = ()=>{
        onInputChange({
            target:{
                name: "hideForUnregisteredAccounts",
                value: !hideForUnregisteredAccounts,
            }
        })
    }

    return (
        <>
            <Grid container  p={1}>
                <Grid item xs={6} md={2} xl={2} textAlign={"right"} >
                    <label className={"IGenericLabel"}>Client ID</label>
                </Grid>
                <Grid item xs={6} md={4} xl={4}>
                    <input type={"text"} className={"ITextbox"} name={"clientID"} value={ clientID } onChange={ onInputChange } />
                </Grid>
                <Grid item xs={6} md={2} xl={2} textAlign={"right"}>
                    <label className={"IGenericLabel"} >Llave secreta</label>
                </Grid>
                <Grid item xs={6} md={4} xl={4}>
                    <input type={"text"} className={"ITextbox"} name={"secretID"} value={ secretID } onChange={ onInputChange } />
                </Grid>

            </Grid>

            <Grid container>
                <Grid item xs={6} md={3} xl={3} mt={2}>
                    <div className={"checkMobile"}>
                        {hideForUnregisteredAccounts && <i className="fa-regular fa-square-check icon-size-1-5"
                                                           onClick={(event) => handleState()}></i>}
                        {!hideForUnregisteredAccounts &&
                            <i className="fa-regular fa-square icon-size-1-5" onClick={(event) => handleState()}></i>}
                        <label style={{ paddingLeft:2 }} className={"IGenericLabel"} onClick={ (event) => handleState() }>Ocultar botón de pago con tarjeta para cuentas no registradas</label>
                    </div>
                </Grid>
                <Grid item xs={6} md={3} xl={3} mt={2}    >

                </Grid>
                <Grid item xs={6} md={3} xl={3} mt={2} pl={1}>

                </Grid>
                <Grid item xs={6} md={3} xl={3} mt={2}>
                    {
                        currentDevice?.uuid && <BtnCambioEstadoTpv device={ currentDevice } />
                    }
                </Grid>

            </Grid>

            <Grid container>
                <Grid item xs={6} md={9} xl={9} mt={10}>
                </Grid>
                <Grid item xs={6} md={3} xl={3} mt={2}>
                    <button className={"btn-alpha-success-2 pad-element"} type={"submit"} onClick={ onClickGuardar }  >
                        Aceptar
                    </button>
                </Grid>

            </Grid>
            {
                openAlert && alphaAlert
            }
        </>
    )

}

FrmCheckout.propTypes = {
    credenciales: PropTypes.object,
    device: PropTypes.object,
    cuenta_uuid: PropTypes.string.isRequired,
}

export default FrmCheckout;